<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
    mounted() {
        console.error('=======', process.env.NODE_ENV);
        //this.$store.dispatch('language');
    },
    methods: {

    }

}
</script>

<style lang="scss"  scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue